"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    lookupList: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: String,
      default: ''
    },
    isBailianFlag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      uploadParams: {
        businessKey: this.$route.query.retailorStoreInfoPk,
        resourceConfigFlag: 'sfe_store'
      } // 上传图片配置
    };
  },
  computed: {
    photo1HistoryTime: function photo1HistoryTime() {
      return this.form.photo1UpdateTime && this.form.photo1UpdateTime.split(' ')[0] || '';
    },
    photo2HistoryTime: function photo2HistoryTime() {
      return this.form.photo2UpdateTime && this.form.photo2UpdateTime.split(' ')[0] || '';
    },
    photo3HistoryTime: function photo3HistoryTime() {
      return this.form.photo3UpdateTime && this.form.photo3UpdateTime.split(' ')[0] || '';
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  methods: {
    updateFormValue: function updateFormValue(v, key, row) {
      row[key] = v;
      // 百炼的校验
      if (this.isBailianFlag) {
        this.$emit('validte-upload', key);
      }
    } // handlePictureCardPreview(val) {
    //   this.$emit('handlePictureCardPreview', val)
    // },
    // photoCloseClickHandle(val) {
    //   this.$emit('photoCloseClickHandle', val)
    // },
    // beforeAvatarUpload(val) {
    //   this.$emit('beforeAvatarUpload', val)
    // },
    // checkFile1(val) {
    //   this.$emit('checkFile1', val)
    // },
    // checkFile2(val) {
    //   this.$emit('checkFile2', val)
    // },
    // checkFile3(val) {
    //   this.$emit('checkFile3', val)
    // }
  }
};